export const LIVE_SESSION_NS = 'components/BunkeringDashboard';

export const i18n = {
  en: {
    massFlowRate: 'Mass Flow Rate',
    volumeFlowRate: 'Volume Flow Rate',
    massTotal: 'Mass Total',
    volumeTotal: 'Volume Total',
    driveGain: 'Drive Gain (%)',
    density: 'Density',
    temperature: 'Temperature',
    pressure: 'Pressure',
    alarms: 'Alarms',
    mfmReadings: 'MFM Readings',
    driveGainAeration: 'Drive Gain & Aeration',
    exportFileName: 'ADP_datalogger_rawdata_{{date}}',
    tubeDamping: 'Tube Damping',
    modals: {
      export: {
        title: 'You are about to export data for {{bargeName}}, {{deviceName}}',
        message:
          'This will export the raw data for the {{deviceName}} on {{bargeName}} as selected in the Bunkering Dashboard.',
        exportingMessage: 'Exporting data...',
        confirmText: 'Export',
        cancelText: 'Cancel',
        error: 'Failed to export the file.',
      },
      print: {
        title: 'Print Failed',
        success: 'Ticket print requested',
        server: 'The server could not generate the printout. Please try again.',
        auth: 'Your session has expired. Please refresh the page and sign in again.',
        rejected: 'The server rejected the print request.',
        offline:
          'This computer has no network connection. Check that it is connected to the barge network and try again.',
        timeout:
          'The server did not respond. It may be offline or disconnected from the barge network. Please try again.',
        blocked:
          'The print request was blocked before it reached the server — possibly by a browser extension (ad blocker), antivirus, or security software. Try disabling ad blockers for this site, or use a different browser.',
        linkFlap:
          'The connection to the server is currently unstable. Please wait a moment and try again.',
        netblock:
          'Could not reach the server. A firewall, antivirus, or certificate issue on this computer may be blocking access, or the server may be down.',
        generic:
          'Something went wrong while preparing the printout in this browser. Try again, or use a different browser.',
      },
    },
  },
};
